"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrencyOptions = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _I18n = _interopRequireDefault(require("I18n"));

var _sortOptions = _interopRequireDefault(require("./sortOptions"));

var _CurrencyLabelFormatters = require("I18n/internal/utils/CurrencyLabelFormatters");

var _currencyOptions;

var currencyOptions = (_currencyOptions = {}, (0, _defineProperty2.default)(_currencyOptions, _CurrencyLabelFormatters.currencyStyles.short, []), (0, _defineProperty2.default)(_currencyOptions, _CurrencyLabelFormatters.currencyStyles.long, []), _currencyOptions);

var getCurrencyOptions = function getCurrencyOptions(_ref) {
  var currencyStyle = _ref.currencyStyle,
      currenciesFilter = _ref.currenciesFilter,
      validCurrencies = _ref.validCurrencies;

  var filter = currenciesFilter || function (currency) {
    return validCurrencies.indexOf(currency.value) >= 0;
  };

  var initialOptions = currencyOptions[currencyStyle];

  if (!validCurrencies && !currenciesFilter && initialOptions.length) {
    return initialOptions;
  } else if (initialOptions.length) {
    return initialOptions.filter(filter);
  }

  currencyOptions[currencyStyle] = Object.keys(_I18n.default.currencySymbols).map(function (code) {
    return {
      text: _CurrencyLabelFormatters.currencyFormatters[currencyStyle](code),
      value: code
    };
  }).sort(_sortOptions.default);

  if (validCurrencies) {
    return currencyOptions[currencyStyle].filter(filter);
  }

  return currencyOptions[currencyStyle];
};

exports.getCurrencyOptions = getCurrencyOptions;